import React from 'react';

import { HeaderContainer } from '../../../serp/components/header/container';
import { SummaryContainer } from '../../../serp/containers/SummaryContainer';
import { PopularPlacesContainer } from '../../PopularPlacesContainer';

/* istanbul ignore next */
export function DefaultHeaderSectionContainer() {
  return (
    <>
      <HeaderContainer />
      {/* Эксперимент добавлен в задаче https://jira.cian.tech/browse/CD-155737, убрать в https://jira.cian.tech/browse/CD-156054 */}
      <PopularPlacesContainer />
      <SummaryContainer />
    </>
  );
}
